import store from "store2"

export default function(o, result, itemWidth, itemHeight){

  var lang = o.store('lang')

  var project = result.roll.split('-')[0]
  var roll = result.roll.split('-')[1]
  var tag = result.tag
  var start = result.start
  var startShort = start.split(':').slice(1).join(':')

  var projectLabel = o.util.getTranslation(o, 'project')
  var rollLabel = o.util.getTranslation(o, 'roll')

  var label = tag[lang]
  var sublabel = `${project}-${roll}`

  var startUrl = start.replace(/:/g,'-')
  var imageFile = `omb_${result.roll}_${MaxResolution}_${startUrl}.jpg`
  var imageUrl = o.util.getUrl('thumb',MaxResolution) + imageFile

  var startSlug = result.start.replace(/\:/g, '-')

  var click = function(){
    history.pushState({}, '', `/roll/${result.roll}/${startSlug}`)
    o.store(`archiveGridItemClicked_${result.roll}_${startSlug}`,true)
    o.render(o)
  }

  var imageDiv = $('<img>')

  var resize = function(w, h){
    itemWidth = w
    itemHeight = h
    imageDiv.attr({
      width: itemWidth,
      height: itemHeight,
    })
    div.css({
      width: `${itemWidth}px`,
      height: `${itemHeight}px`,
    })
  }

  var isActive = false

  var isVisited = o.store(`archiveGridItemClicked_${result.roll}_${startSlug}`)

  var start = function(){

    if(isActive){ return }
    isActive = true

    var labelDiv = o.component.gridItemLabel(o, label, sublabel)

    if(isVisited){
      labelDiv.addClass('visited')
    }

    imageDiv
    .attr({
      src: imageUrl,
      width: itemWidth,
      height: itemHeight,
      zIndex: 0,
    })
    .css({
      borderRight: '5px solid black',
      borderBottom: '5px solid black',
      position: 'absolute',
      top: 0,
      left: 0,
    })

    div
    .css({
      cursor: 'pointer',
    })
    .append([
      imageDiv,
      labelDiv,
    ])
    .hover(
      function(){
        // o.util.soundTick(o)
        labelDiv.css({color: o.colors.red})
      },
      function(){
        labelDiv.css({color: ''})
      }
    )

  }

  var stop = function(){

    if(!isActive){ return }
    isActive = false

    div
    .empty()
    .unbind('mouseenter')
    .unbind('mouseleave')

  }

  var div =
    $('<div>')
    .css({
      borderRight: '5px solid black',
      borderBottom: '5px solid black',
      display: 'inline-flex',
      position: 'relative',
      backgroundColor: 'rgba(255,255,255,0.1)',
      width: `${itemWidth}px`,
      height: `${itemHeight}px`,
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'top',
      lineHeight: '1.2em',
      cursor: 'pointer',
    })
    .click(click)

  div.start = start
  div.stop = stop
  div.resize = resize

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/box/grid/item/item.js